import { sectionType } from '@/views/website/products/components/description/common/types';
export const IDENTIFIER_TAGS = {
  heading: 'heading',
  body_text: 'body_text',
  bg_image: 'bg_image',
  promo_pill: 'promo_pill',
  icon_grid: 'icon_grid',
  cta: 'cta',
  rating_badge: 'rating_badge',
};
export default {
  crawlType: 'hero_banner',
  matchTemplates: [
    {
      type: sectionType.sectionBannerB1,
      tags: [IDENTIFIER_TAGS.heading, IDENTIFIER_TAGS.body_text, IDENTIFIER_TAGS.bg_image],
      priority: 1,
    },
    {
      type: sectionType.sectionCardBannerRivoneed,
      tags: [
        IDENTIFIER_TAGS.heading,
        IDENTIFIER_TAGS.body_text,
        IDENTIFIER_TAGS.bg_image,
        IDENTIFIER_TAGS.promo_pill,
        IDENTIFIER_TAGS.icon_grid,
        IDENTIFIER_TAGS.cta,
        IDENTIFIER_TAGS.rating_badge,
      ],
      priority: 2,
    },
    {
      type: sectionType.sectionCardBanner02Rivoneed,
      tags: [],
      priority: 3,
    },
  ],
};
